// Asks the History what is already loaded for this file and week. The route only accepts GET:
// useFetchMutation defaults to POST, which the server answered with 405 until 2026-10-22 and
// every reload went through.
// Throws when the check itself fails, so the caller can refuse to upload without an answer.
//
// The answer, every list holding one entry per load ({ filename, shop_sign, client, category,
// sheets, loaded_at, loaded_by, same_name, same_content }):
// - sameFile: this file (same name or same content) in this week, which the server refuses;
// - otherFiles: other files of this week, allowed with a warning;
// - elsewhere: this file in the same year and week under another shop sign, client or univers.
export async function checkExistingLoad(request, apiBaseUrl, { shopSign, client, year, week, category }, { filename, fileHash } = {}) {
  const queryParams = new URLSearchParams({
    shop_sign: shopSign,
    client,
    year,
    week,
    category: category || 'default'
  });
  if (filename) queryParams.set('filename', filename);
  if (fileHash) queryParams.set('file_hash', fileHash);

  const result = await request({ url: `${apiBaseUrl}/api/history/exists/?${queryParams}`, method: 'GET' });
  return {
    exists: Boolean(result.exists),
    count: result.count || 0,
    sameFile: result.same_file || [],
    otherFiles: result.other_files || [],
    elsewhere: result.elsewhere || [],
  };
}

// SHA-256 of the file in hexadecimal, as the server stores it in processor_history.file_hash.
// Null where the browser cannot hash (no WebCrypto outside HTTPS): the server still compares
// the content when the file is uploaded.
export async function fileHash(file) {
  const subtle = window.crypto?.subtle;
  if (!subtle || !file?.arrayBuffer) return null;
  const digest = await subtle.digest('SHA-256', await file.arrayBuffer());
  return [...new Uint8Array(digest)].map((byte) => byte.toString(16).padStart(2, '0')).join('');
}

// One line per load in the upload screen's warnings, e.g.
// "Export_S41 (2 feuilles, chargé le 20/10/2026 par Ilyas WADJINNY)"
export function describeLoad({ filename, sheets, loaded_at: loadedAt, loaded_by: loadedBy }) {
  const details = [`${sheets} feuille${sheets > 1 ? 's' : ''}`];
  if (loadedAt) details.push(`chargé le ${new Date(loadedAt).toLocaleDateString('fr-FR')}${loadedBy ? ` par ${loadedBy}` : ''}`);
  return `${filename} (${details.join(', ')})`;
}
